export default __webpack_public_path__ + "static/media/about-us-choir.2be45e28.jpeg";